import React, { useLayoutEffect } from "react";
import SettingsContextProvider from "./context/SettingsContext";
import { useSettings } from "./hooks";
import Editor from "./Editor";
import { ConfigProvider } from "antd";
import zhCN from "antd/locale/zh_CN";

function ThemedPage({ children }) {
  const { setSettings } = useSettings();

  useLayoutEffect(() => {
    const theme = localStorage.getItem("theme");
    if (theme === "dark") {
      setSettings((prev) => ({ ...prev, mode: "dark" }));
      const body = document.getElementById("data-model-editor");
      if (body.hasAttribute("theme-mode")) {
        body.setAttribute("theme-mode", "dark");
      }
    } else {
      setSettings((prev) => ({ ...prev, mode: "light" }));
      const body = document.getElementById("data-model-editor");
      if (body.hasAttribute("theme-mode")) {
        body.setAttribute("theme-mode", "light");
      }
    }
  }, []);

  return children;
}

export default function DataModelEditorWrapper() {
  return (
    <div id="data-model-editor" theme-mode="light">
      {/* <LocaleProvider locale={zh_CN}></LocaleProvider> */}
      <ConfigProvider locale={zhCN}>
        <SettingsContextProvider>
          <ThemedPage>
            <Editor />
          </ThemedPage>
        </SettingsContextProvider>
      </ConfigProvider>
    </div>
  );
}
